import { render, staticRenderFns } from "./Snackbars.vue?vue&type=template&id=4c4f6864"
import script from "./Snackbars.vue?vue&type=script&lang=js"
export * from "./Snackbars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports